import { EntityType } from '../../../@types/entityTypes';
import { ReportOutputType, IDocumentConfig, ReportType } from '../../schema/p4types';
import GenerateSalesLedgerAllocationAuditReportMutation from '../../mutations/customer/GenerateSalesLedgerAllocationAuditReportMutation.graphql';

export enum SalesAllocationAction {
  AllocationAuditReport = 'SALES_ALLOCATION_AUDIT_REPORT',
}

const SalesAllocationAuditReport: EntityType = {
  type: 'SalesAllocationAuditReport',
  title: 'Sales Allocation Audit Report',
  screenReference: SalesAllocationAction.AllocationAuditReport,
  generate: GenerateSalesLedgerAllocationAuditReportMutation,
  configuration: {
    defaultConfig: {
      output: ReportOutputType.LocalPrinter,
    },
    field: undefined as unknown as keyof IDocumentConfig, //There's no defaults configurable for sales allocation audit report, so cheating a bit here.
    title: 'Sales Allocation Audit Report',
    reportType: ReportType.AllocationAuditReport,
  },
};

export default SalesAllocationAuditReport;
